module.exports = __webpack_public_path__ + "media/images/add_status_form_img-32798f0cb71f64c4a1eb46eabde069f3.svg";